export default "__VITE_ASSET__MozarrE3__"